import { useAppContext } from "../../../AppContext";
import { AppTooltip } from "../tooltip/AppTooltip";
import styles from "./HeaderTitleSectionWithBackground.module.scss";
import { classNames } from "primereact/utils";

import { dvSize } from "../../infrastructure/utilities/viewportUnitsUtility";
interface IHeaderWithBackgroundProps {
  className?: string;
  text: string;
  width?: string;
  tooltip?: string;
  dataOnboarding?: string;
}

export const HeaderTitleSectionWithBackground = ({
  className,
  text,
  width,
  tooltip,
  dataOnboarding,
}: IHeaderWithBackgroundProps) => {
  const { isDesktopOrTablet } = useAppContext();

  if (!width) {
    if (isDesktopOrTablet) {
      width = "600px";
    } else {
      width = dvSize("80dvw");
    }
  }
  return (
    <div
      style={{ width: width }}
      className={classNames(styles.root, className)}
      data-onboarding={dataOnboarding}
    >
      {text}
      <AppTooltip content={tooltip} />
    </div>
  );
};
